import React, { useState, useEffect } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import axios from "axios";
import {
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { getAxiosHeaders } from "../utils/Utils";
import { baseURLs } from "../utils/Constants";
import { Input } from "antd";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  Row,
  Col,
  PreviewAltCard,
  BackTo,
} from "../components/Component";
import { Link } from "react-router-dom";
import { ProductCategoryTable } from "./components/tables/ProductCategoryTable";
import { AlertModal, SuccessModal } from "./components/AlertModals";
import { AddExpenseCategoryModal } from "./components/ExpenseCategoryModal";
import { ExpenseCategoryTable } from "./components/tables/ExpenseCategoryTable";

const ExpenseCategories = ({ history, match }) => {
  const [sm, updateSm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [requesting, setRequesting] = useState(false);
  const [businessID, setBusinessID] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [addedCategoryCount, setAddedCategoryCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState({
    title: "",
    message: "",
  });
  const [activeModal, setActiveModal] = useState(null);
  const [tableKey, setTableKey] = useState(0);

  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const updateList = (category) => {
    setSuccessMessage({
      title: "Added",
      message: "The category has been added successfully.",
    });
    toggleModal("successModal");
    setTableKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    setLoading(true);
    const businessID = parseInt(match.params.businessID, 10);
    if (!Number.isInteger(businessID)) {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }

    localStorage.setItem("current_business_id", businessID);
    let businesses = JSON.parse(localStorage.getItem("my_businesses"));
    let currentBusiness = businesses?.find(
      (business) => business.business_id == businessID
    );

    if (currentBusiness == undefined || null || "") {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }

    setBusinessInfo(currentBusiness);
    setBusinessID(businessID);
    setLoading(false);
  }, [match.params.businessID]);

  return (
    <React.Fragment>
      <Head title="Expenses Category" />
      <Content>
        {loading ? (
          <Block className="nk-block-middle nk-auth-body text-center wide-xs">
            <div className="inner-pre-loader">
              <Spinner color="dark" />
            </div>
          </Block>
        ) : (
          <>
            <BlockHead className="mb-4" size="sm">
              <div className="nk-block-between">
                <BlockHeadContent>
                  <BlockDes className="text-soft">
                    <p>{businessInfo.name}</p>
                  </BlockDes>
                  <BlockTitle page tag="h3">
                    Expenses Categories
                  </BlockTitle>
                </BlockHeadContent>
                <BlockHeadContent>
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <Button
                      className={`btn-icon btn-trigger toggle-expand me-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => updateSm(!sm)}
                    >
                      <Icon name="more-v"></Icon>
                    </Button>
                    <div
                      className="toggle-expand-content"
                      style={{ display: sm ? "block" : "none" }}
                    >
                      <ul className="nk-block-tools g-3">
                        <li>
                          <Button
                            color={`primary`}
                            onClick={() => toggleModal("addCategoryModal")}
                          >
                            <Icon name="list-thumb"></Icon>
                            <span>Add Category</span>
                          </Button>
                        </li>
                        <li>
                          <BackTo
                            className="mb-3"
                            history={history}
                            link={`/expenses/b/${businessID}`}
                            icon="arrow-left"
                            type="button"
                          >
                            Go Back
                          </BackTo>
                        </li>
                      </ul>
                    </div>
                  </div>
                </BlockHeadContent>
              </div>
            </BlockHead>
            <ExpenseCategoryTable
              key={tableKey}
              history={history}
              businessID={businessID}
              addedCategoryCount={addedCategoryCount}
            />

            {activeModal === "addCategoryModal" && (
              <AddExpenseCategoryModal
                businessID={businessID}
                currency={businessInfo.currency}
                toggleModal={() => toggleModal("addCategoryModal")}
                updateList={updateList}
                showModal={true}
              />
            )}

            {activeModal === "successModal" && (
              <SuccessModal
                showModal={true}
                toggleModal={() => toggleModal("successModal")}
                headerText={successMessage.title}
                descriptionText={successMessage.message}
              />
            )}
          </>
        )}
      </Content>
    </React.Fragment>
  );
};

export default ExpenseCategories;
